import React from 'react';
import { css } from '@emotion/css';
import { css as globalCss, Global } from '@emotion/react';
import { withBasicStyles } from '@/styles/common';

export const useStyles = withBasicStyles(() => ({
  view: css`
    /* view container */
  `,
}));

export const GlobalStyle: React.FC = () => (
  <Global
    styles={globalCss`
      .cm-editor {
        background: #fff;
        border-radius: 8px;
        border: 1px solid #d9d9d9;
      }

      .cm-scroller {
        border-radius: 8px;
      }
    `}
  />
);

export default useStyles;
